import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
import { SearchBox } from "../searchbox";
export function ListSearchBox(_a) {
    var className = _a.className, restProps = __rest(_a, ["className"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(SearchBox, __assign({ iconPlacement: "start", className: classNames(classPrefix + "-list__search-box", className), simple: true }, restProps)));
}
//# sourceMappingURL=ListSearchBox.js.map